import Blazy from "blazy";

class Video {
    constructor() {
        this.container = ".js-video";
        this.element = ".js-video-lazy";
        this.success = "video--loaded";
        this.error = "video--error";
    }

    lazyLoad() {
        const bLazy = new Blazy({
            constainer: this.container,
            selector: this.element,
            successClass: this.success,
            errorClass: this.error,
        });
        return bLazy;
    }

    play(iframe) {
        const source = iframe.data("src");
        iframe.attr("src", source);
    }

    destroy(iframe) {
        const source = "";
        iframe.attr("src", source);
    }
}

export default Video;



// WEBPACK FOOTER //
// ../project/craft/src/components/video/video.js